import React, { useState, useRef, useEffect } from "react"
import {
  Form,
  Alert,
  Button,
  Card,
  Col,
  Row,
  Spinner,
  Dropdown,
} from "react-bootstrap"
import { useAuth } from "../contexts/AuthContext"
import { Link } from "react-router-dom"
import { db } from "../firebase"
import { doc, getDoc, updateDoc } from "firebase/firestore"
import CenteredContainer from "./CenteredContainer"
import Image from "react-bootstrap/Image"
import {
  optionsDegree,
  optionsOccupation,
  optionsAffiliation,
} from "../helpers/Data"

// import Nav from 'react-bootstrap/Nav';

export default function Update() {
  const [error, setError] = useState("")
  const { currentUser } = useAuth()
  const affiliationRef = useRef()
  const degreeRef = useRef()
  const nameRef = useRef()
  const surnameRef = useRef()
  const occupationRef = useRef()
  const paperRef = useRef()

  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState("")

  const [currentProfile, setCurrentProfile] = useState({})

  const [selectedAffiliation, setSelectedAffiliation] = useState("")
  const [affiliationText, setAffiliationText] = useState("")

  const docRef = doc(db, "usersNew", currentUser.uid)

  useEffect(() => {
    ;(async () => docSnap())()
  }, [])

  const docSnap = async () => {
    setLoading(true)
    // Get current profile
    const res = await getDoc(docRef)
    // Set current profile
    setCurrentProfile(res.data())

    // Reset loading state
    setLoading(false)
  }

  // selectElement('degree', 'Master');
  // Update profile data
  async function updateProfile(newProfileData) {
    const data = newProfileData
    try {
      await updateDoc(docRef, data)
    } catch (err) {
      console.log(err)
    }
  }

  // Submit changes to profile
  async function handleSubmit(e) {
    e.preventDefault()

    // const promises = []
    setLoading(true)
    setError("")

    let newProfileData = {}

    // Update Name field
    if (
      nameRef.current.value !== currentProfile.Name &&
      nameRef.current.value !== ""
    ) {
      newProfileData.Name = nameRef.current.value
    }

    // Update Surname field
    if (
      surnameRef.current.value !== currentProfile.Surname &&
      surnameRef.current.value !== ""
    ) {
      newProfileData.Surname = surnameRef.current.value
    }

    // update Affiliation field
    if (
      affiliationRef.current.value !== currentProfile.Affiliation &&
      affiliationRef.current.value !== ""
    ) {
      newProfileData.Affiliation = affiliationRef.current.value
    }

    // Update Degree field
    if (
      degreeRef.current.value !== currentProfile.Degree &&
      degreeRef.current.value !== ""
    ) {
      newProfileData.Degree = degreeRef.current.value
    }

    // Update occupation field
    if (
      occupationRef.current.value !== currentProfile.occupation &&
      occupationRef.current.value !== ""
    ) {
      newProfileData.occupation = occupationRef.current.value
    }
    console.log(newProfileData)

    // // Paper ref
    // if (paperRef.current.value !== currentProfile.paperID) {
    //   newProfileData.paperID = paperRef.current.value
    // }

    if (Object.keys(newProfileData).length === 0) {
      setMessage("Nochange")
      // console.log("Nothing to update")
    } else {
      setMessage("Updated")
      // console.log("Actualizando")

      LoadSpinner()

      try {
        await updateProfile(newProfileData)
      } catch (err) {
        setError(err.message)
        setMessage(error)
      }
    }

    setLoading(false)
  }

  const LoadSpinner = () => {
    return (
      <>
        {loading && (
          <div className={"d-flex justify-content-center"}>
            <Spinner animation='border' role='status'>
              <span className='visually-hidden'> Loading...</span>
            </Spinner>
          </div>
        )}
      </>
    )
  }

  const handleDropdownChange = (event) => {
    const selectedValue = event.target.value
    setSelectedAffiliation(selectedValue)
    affiliationRef.current.value = selectedValue // Update affiliationRef value
    if (selectedValue === "Otro") {
      affiliationRef.current.focus()
    }
  }

  const handleTextChange = (event) => {
    setAffiliationText(event.target.value)
  }

  return (
    <CenteredContainer>
      {/*  Update Profile */}
      <Card>
        <Image
          // src={require("../images/Group12.jpg")}
          src={require("../images/Group9.jpeg")}
          rounded
          className='w-100'
        ></Image>
      </Card>
      <Card className='mt-1'>
        <Card.Body>
          <h4 className='text-center mb-4 mt-4'>Update Profile</h4>
          {message === "Updated" && (
            <Alert variant='success'>
              Tus datos se actualizaron correctamente
            </Alert>
          )}
          {message === "Nochange" && (
            <Alert variant='warning'>Nada que actualizar</Alert>
          )}
          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} id='name'>
              <Form.Label column xs={5}>
                Nombre{" "}
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  defaultValue={currentProfile.Name}
                  ref={nameRef}
                  size='sm'
                  required
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} id='name'>
              <Form.Label column xs={5}>
                Apellido{" "}
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  defaultValue={currentProfile.Surname}
                  ref={surnameRef}
                  size='sm'
                  required
                />
              </Col>
            </Form.Group>

            {/* Affiliation */}
            <Form.Group as={Row} id='affiliation' className='mt-2'>
              <Form.Label column xs={5}>
                Institución
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={affiliationRef}
                  value={selectedAffiliation}
                  onChange={handleDropdownChange}
                  placeholder='Select your Affiliation'
                  size='sm'
                  required
                >
                  <option value={currentProfile.Affiliation}>
                    {currentProfile.Affiliation}
                  </option>

                  {optionsAffiliation.map((option, index) => {
                    if (option.value === currentProfile.Affiliation) {
                      return (
                        <option key={index} value={option.value} selected>
                          {option.label}
                        </option>
                      )
                    } else {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                          {/* {console.log(selectedAffiliation)} */}
                        </option>
                      )
                    }
                  })}
                </Form.Select>
                {selectedAffiliation === "other" && (
                  <div>
                    <Form.Label column xs={5}>
                      Institución:
                    </Form.Label>

                    <Form.Control
                      type='text'
                      // defaultValue={currentProfile.Affiliation}
                      ref={affiliationRef}
                      onChange={handleTextChange}
                      size='sm'
                      required
                      className='mt-1'
                    />
                  </div>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} id='degree' className='mt-2'>
              <Form.Label column xs={5}>
                Título académico
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={degreeRef}
                  placeholder='Select your degree'
                  size='sm'
                  required
                >
                  {optionsDegree.map((option, index) => {
                    if (option.value === currentProfile.Degree) {
                      return (
                        <option key={index} value={option.value} selected>
                          {option.label}
                        </option>
                      )
                    } else {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    }
                  })}
                </Form.Select>
              </Col>
            </Form.Group>

            <Form.Group as={Row} id='degree' className='mt-2'>
              <Form.Label column xs={5}>
                Ocupación
              </Form.Label>
              <Col xs={7}>
                <Form.Select
                  aria-label='Default select example'
                  ref={occupationRef}
                  placeholder='Select your degree'
                  size='sm'
                  required
                >
                  {optionsOccupation.map((option, index) => {
                    if (option.value === currentProfile.occupation) {
                      return (
                        <option key={index} value={option.value} selected>
                          {option.label}
                        </option>
                      )
                    } else {
                      return (
                        <option key={index} value={option.value}>
                          {option.label}
                        </option>
                      )
                    }
                  })}
                </Form.Select>
              </Col>
            </Form.Group>

            {/* Paper ID
            <div className='w-100 fs-6'>
              Por favor incluye el numero de tu documento.
            </div>
            <div className='w-100 fs-6 text-secondary mt-0 text-center'>
              Please include you paper ID.
            </div>

            <Form.Group as={Row} id='paperID' className='mt-3'>
              <Form.Label column xs={5}>
                Paper ID
              </Form.Label>
              <Col xs={7}>
                <Form.Control
                  type='text'
                  placeholder='Paper ID'
                  ref={paperRef}
                  size='sm'
                  defaultValue={currentProfile.paperID}
                />
              </Col>
            </Form.Group> */}

            <Button disabled={loading} className='w-100 mt-4' type='submit'>
              Actualizar | Update
            </Button>
          </Form>
        </Card.Body>
      </Card>

      {/* Log out */}

      <div className='w-100 text-center mt-2'>
        <Link to='/'>Volver al Menu | Go back</Link>
      </div>
    </CenteredContainer>
  )
}
